import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  AbstractControl
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import { MatDialog } from "@angular/material";
import { ViewChild, TemplateRef } from "@angular/core";
import { TranslationService } from "src/app/translation.service";
import { DataService } from "./../../data.service";
import { AppConfig } from "./../../config";
import { GUID } from "./../../guid";
import { SharedDataService } from "src/app/shared-data.service";

@Component({
  selector: "app-metafieldnew",
  templateUrl: "./metafieldnew.component.html",
  styleUrls: ["./metafieldnew.component.scss"]
})
export class MetafieldNewComponent implements OnInit {
  @ViewChild("translateDialog", { static: false })
  translateDialog!: TemplateRef<any>;

  @ViewChild("filterDialog", { static: false })
  filterDialog!: TemplateRef<any>;

  @ViewChild("fieldUsageDialog", { static: false })
  fieldUsageDialog!: TemplateRef<any>;

  @ViewChild("standardPicklistDialog", { static: false })
  standardPicklistDialog!: TemplateRef<any>;

  @ViewChild("editPicklistDialog", { static: false })
  editPicklistDialog!: TemplateRef<any>;

  profileDisplayedColumns = ["profilename", "visible", "readonly"];
  dialogRef: any;
  filterdialogRef: any;
  fieldUsagedialogRef: any;
  picklistOptions = [];

  fieldList = [];
  operatorList = [];
  typeList = [];
  showFilterForm: boolean = false;
  checkboxValueList = [
    { label: "True", value: true },
    { label: "False", value: false }
  ];
  metafield: any;
  metalookupfilters: any;
  metaProfileFieldJSON: string | any[];
  fgsArray = new Array<FormGroup>();
  isLoading = false;
  isError = false;
  errorMessage = "";
  metafieldId = "";
  fieldName = "";
  labelName = "";
  metaobjectId = "";
  metaobjectName = "";
  parentobjectId = "";
  parentobjectName = "";
  embeddedObject = false;
  virtualObject = false;
  applicationId = "";
  languages: Array<any>;
  translatedLabels = [];
  mode = "New";
  guid: GUID;
  profiles: string | any[];
  modifiedby: "";
  modifieddate: "";
  fieldAttributesDefnJson: any;
  fieldAttributeArray = [];

  fieldTypeSelect = [];

  dataTypeSelect = [];
  sortOrderSelect = [];
  // sortBySelect = [];

  sortBySelect: any[] = [];

  relatedToSelect = [];
  oldValues: any = {}; // To store the old values

  showStandardPicklist = false;
  displayedColumns: string[] = [
    "action",
    "picklistlabel",
    "picklistname",
    "defaultpicklist",
    "exclude",
    "addtorecordtype",
    "converted",
    "closed",
    "funnelstage"
  ];
  dataSource: any;
  detailForm = this.fb.group({
    metaobjectid: "",
    metaobjectname: "",
    id: "",
    labelname: "",
    fieldname: "",
    fieldtype: "",
    standard: true,
    primaryfield: false,
    required: false,
    tenantfield: false,
    defaultvalue: "",
    parentobjectid: new FormControl({ value: "", disabled: true }),
    parentobjectname: new FormControl({ value: "", disabled: true }),
    description: "",
    hinttext: "",
    helptext: "",
    embeddedobject: new FormControl({ value: false, disabled: true }),
    virtualobject: new FormControl({ value: false, disabled: true }),
    active: true,
    attributes: {},
    sinceversionseq: 0,
    deprecatedversionseq: 0
  });

  fieldUsageForm = this.fb.group({
    fieldusage: "",
    sensitivitylevel: ""
  });
  picklistValueList = [];

  fieldUsageSelect = [
    { value: "", label: "--None--" },
    { value: "Active", label: "Active" },
    { value: "DeprecateCandidate", label: "DeprecateCandidate" },
    { value: "Hidden", label: "Hidden" }
  ];

  funnelstagesSelect = [
    { value: "TOFU (Awareness)", label: "TOFU (Awareness)" },
    { value: "MOFU (Consideration)", label: "MOFU (Consideration)" },
    { value: "BOFU (Decision)", label: "BOFU (Decision)" },
    { value: "Customer (Closed-Won)", label: "Customer (Closed-Won)" },
    { value: "Out of Funnel", label: "Out of Funnel" }
  ];

  defaultObj = [
    { value: "Users", label: "Users" },
    { value: "RecordType", label: "RecordType" }
  ];

  sensitivitylevelSelect = [
    { value: "", label: "--None--" },
    { value: "Public", label: "Public" },
    { value: "Internal", label: "Internal" },
    { value: "Confidential", label: "Confidential" },
    { value: "Restricted", label: "Restricted" },
    { value: "MissionCritical", label: "MissionCritical" }
  ];

  compliancesToDo = [
    { value: "", label: "--None--", selected: false },
    { value: "Public", label: "Public", selected: false },
    { value: "Internal", label: "Internal", selected: false },
    { value: "Confidential", label: "Confidential", selected: false },
    { value: "Restricted", label: "Restricted", selected: false },
    { value: "MissionCritical", label: "MissionCritical", selected: false }
  ];
  relationVisibilitySelect = [
    { value: "global", label: "Global" },
    { value: "local", label: "Local" }
  ];
  compliancesDone = [];

  filterForm: FormGroup;
  filteritems: FormArray;
  fields = [];
  standardpicklistdialogRef: any;
  showEditPicklistDialog: any;
  editpicklistdialogRef: any;
  selectedIndex: any;
  relatedToObject: any;
  picklistType: any;

  // updateDisplayedColumns() {
  //   // Conditionally update the displayed columns
  //   if (
  //     (this.metaobjectName !== "Lead" && this.metaobjectName !== "Enquiry") ||
  //     this.fieldName !== "status"
  //   ) {
  //     const index = this.displayedColumns.indexOf("converted");
  //     if (index > -1) {
  //       // Remove "converted" from the displayedColumns array if the conditions aren't met
  //       this.displayedColumns.splice(index, 1);
  //     }
  //   }
  // }

  relatedToRequiredTypes = [
    "lookup",
    "class_section",
    "masterdetail",
    "rollupsummary",
    "map"
  ];

  updateDisplayedColumns() {
    const shouldShowConvertedColumn =
      ((this.metaobjectName === "Enquiry" || this.metaobjectName === "Lead") &&
        this.fieldName === "status") ||
      (this.metaobjectName === "Opportunity" && this.fieldName === "stage");

    const index = this.displayedColumns.indexOf("converted");

    if (!shouldShowConvertedColumn && index > -1) {
      // Remove "converted" from the displayedColumns array if the conditions aren't met
      this.displayedColumns.splice(index, 1);
    } else if (shouldShowConvertedColumn && index === -1) {
      // Optionally: Add "converted" if it should be shown but is missing
      this.displayedColumns.push("converted");
    }

    // ----- Funnel Stage column -----
    const shouldShowFunnelColumn =
      (this.metaobjectName === "Enquiry" || this.metaobjectName === "Lead") &&
      this.fieldName === "status";

    const funnelIndex = this.displayedColumns.indexOf("funnelstage");

    if (!shouldShowFunnelColumn && funnelIndex > -1) {
      this.displayedColumns.splice(funnelIndex, 1); // ✅ fixed variable name
    } else if (shouldShowFunnelColumn && funnelIndex === -1) {
      this.displayedColumns.push("funnelstage");
    }

    const shouldShowClosedColumn =
      this.metaobjectName === "Opportunity" && this.fieldName === "stage";

    const closedIndex = this.displayedColumns.indexOf("closed");

    if (!shouldShowClosedColumn && closedIndex > -1) {
      // Remove "converted" from the displayedColumns array if the conditions aren't met
      this.displayedColumns.splice(closedIndex, 1);
    } else if (shouldShowClosedColumn && closedIndex === -1) {
      // Optionally: Add "converted" if it should be shown but is missing
      this.displayedColumns.push("closed");
    }
  }

  fieldSelected(
    event: { id: any; fieldtype: any; options: string; metaobjectname: string },
    index: number
  ) {
    console.log("fieldSelected");
    console.log("index", index);
    console.log("event", event);

    var i = 0;
    var arrayControl = this.filterForm.get("filteritems") as FormArray;
    for (let c of arrayControl.controls) {
      if (i == index) {
        console.log("matching", c);
        c.get("fieldid").setValue(event.id);
        c.get("fieldtype").setValue(event.fieldtype);
        c.get("options").setValue(event.options);
        c.get("metaobjectname").setValue(event.metaobjectname);

        if (c.get("fieldoperator").value == "") {
          c.get("fieldoperator").setValue("equals"); //default operator set
        }
        if (event.options != "") {
          var arr = JSON.parse(event.options);
          this.picklistValueList[index] = arr;
          c.get("fieldoperator").setValue("equals"); //default operator set
        }
        c.get("fieldvalue").setValue("");
        break;
      }
      i++;
    }
  }

  addFilter(index: any) {
    console.log(index);
    if (this.filteritems != null && this.filteritems.length < 10) {
      this.addFilterItem("", "", "", "", "", "", "", "", "");
    }
  }

  removeFilter(index: any) {
    this.removeFilterItem(index);
  }
  removeFilterItem(index: number) {
    if (index > 0) {
      this.filteritems.removeAt(index);
    }
  }
  createfilterItem(
    id: any,
    name: any,
    ftype: any,
    opt: any,
    opr: any,
    typ: any,
    vl: any,
    flogic: string,
    objname: string
  ): FormGroup {
    return this.fb.group({
      //fieldlist: fldlist,
      //operatorlist: oplist,
      fieldid: id,
      fieldname: name,
      fieldtype: ftype,
      options: opt,
      fieldoperator: opr,
      type: typ,
      fieldvalue: vl,
      filterlogic: flogic,
      metaobjectname: objname
      // filtertype: "",
      // errormessage: "",
      // lookuptext: "",
      // active: "",
    });
  }
  addFilterItem(
    id: string,
    name: string,
    ftype: string,
    opt: string | any[],
    opr: string,
    typ: any,
    vl: string,
    flogic = "AND",
    objname: string
  ): void {
    this.filteritems = this.filterForm.get("filteritems") as FormArray;
    this.filteritems.push(
      this.createfilterItem(name, id, ftype, opt, opr, typ, vl, flogic, objname)
    );
    this.picklistValueList.push([]);
  }

  // addFilterItem(
  //   id: string,
  //   name: string,
  //   ftype: string,
  //   opt: string | any[],
  //   opr: string,
  //   typ: any,
  //   vl: string,
  //   flogic = "AND",
  //   objname: string
  // ): void {
  //   this.filteritems = this.filterForm.get("filteritems") as FormArray;

  //   // Ensure uniqueness based on 'fieldid'
  //   const isDuplicate = this.filteritems.controls.some(
  //     (ctrl: AbstractControl) => {
  //       console.log("fieldid", ctrl.get("fieldname").value);
  //       console.log("id", id);
  //       return ctrl.get("fieldname").value === id;
  //     }
  //   );

  //   if (isDuplicate) {
  //     console.log("Duplicate filter item skipped:", { id, opr, vl, objname });
  //     return;
  //   }

  //   // If not duplicate, push
  //   this.filteritems.push(
  //     this.createfilterItem(name, id, ftype, opt, opr, typ, vl, flogic, objname)
  //   );
  //   this.picklistValueList.push([]);
  // }

  profileForm = this.fb.group({
    metaprofilefields: this.fb.array([])
  });
  data: any;

  get metaprofilefields(): FormArray {
    return this.profileForm.get("metaprofilefields") as FormArray;
  }

  attributeForm: FormGroup;
  attributeitems: FormArray;

  createItem(a: any, t: any, v: any, p = "", h: any): FormGroup {
    return this.fb.group({
      attr: a,
      type: t,
      value: v,
      placeholder: p,
      hint: h
    });
  }

  addAttributeItem(
    a: any,
    t: any,
    v: string | boolean | number,
    p = "",
    h: any
  ): void {
    this.attributeitems = this.attributeForm.get("attributeitems") as FormArray;
    this.attributeitems.push(this.createItem(a, t, v, p, h));
  }

  picklistValueChangedOld(event: { target: { value: any } }) {
    var options = [];
    console.log(event);
    console.log("event", event.target.value);
    var txtValue = event.target.value;
    if (txtValue != "") {
      var arr = txtValue.split("\n");
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].trim() != "") {
          options.push({
            value: arr[i],
            label: arr[i]
          });
        }
      }
    }

    var optionValue = JSON.stringify(options);
    console.log("value", optionValue);
    this.picklistOptions = options;

    if (options != null) {
      this.dataSource = options.map((item) => ({
        // id: item.id,
        // label: item.labelname,
        picklistlabel: item.label,
        picklistname: item.value,
        funnelstage: item.funnelstage,
        defaultpicklist: item.defaultpicklist,
        exclude: item.exclude,
        converted: item.converted,
        closed: item.closed
      }));
    }

    var arrayControl = this.attributeForm.get("attributeitems") as FormArray;
    for (let c of arrayControl.controls) {
      if (c.get("attr").value == "options") {
        // c.get("value").setValue(optionValue);
        c.get("value").setValue(options);
        break;
      }
    }
  }

  picklistValueChanged(event: {
    target: {
      value: any;
      label: any;
      funnelstage: any;
      defaultpicklist: any;
      exclude: any;
      addtorecordtype: any;
      converted: any;
      closed: any;
    };
  }) {
    if (!event.target.label || event.target.label.trim() === "") {
      console.log("Empty label, skipping processing.");
      return;
    }

    var options = [];
    console.log(event);
    console.log("event", event.target.value);
    console.log("event", event.target.defaultpicklist);

    var txtValue = event.target.value;
    var txtLabel = event.target.label;
    var txtfunnal = event.target.funnelstage;
    var defPicklist = event.target.defaultpicklist;
    var exclude = event.target.exclude;
    var addToRecordType = event.target.addtorecordtype;
    var converted = event.target.converted;
    var closed = event.target.closed;

    if (txtValue != "") {
      var arr = txtValue.split("\n");
      var arrLbl = txtLabel.split("\n");
      var funnelstage = txtfunnal.split("\n");
      var arrPic = defPicklist.split("\n");
      var Exclude = exclude.split("\n");
      var arrAddToRecordType = addToRecordType.split("\n");
      var Converted = converted.split("\n");
      var Closed = closed.split("\n");

      for (let i = 0; i < arr.length; i++) {
        if (arr[i].trim() != "") {
          options.push({
            value: arr[i],
            label: arrLbl[i],
            funnelstage: funnelstage[i],

            // funnelstage: this.valuePicklistForm.controls["funnelstage"].value,
            // defaultpicklist: Boolean(arrPic[i]),
            defaultpicklist: arrPic[i] === "false" ? false : Boolean(arrPic[i]),
            exclude: Exclude[i] === "false" ? false : Boolean(Exclude[i]),
            addtorecordtype:
              arrAddToRecordType[i] === "false"
                ? false
                : Boolean(arrAddToRecordType[i]),
            converted: Converted[i] === "false" ? false : Boolean(Converted[i]),
            closed: Closed[i] === "false" ? false : Boolean(closed[i]),
            sortbyalphabet:
              this.valuePicklistForm.controls["sortbyalphabet"].value
          });
        }
      }
      console.log(this.valuePicklistForm.controls["sortbyalphabet"].value);
    }

    var optionValue = JSON.stringify(options);
    console.log("value", optionValue);
    this.picklistOptions = options;

    if (options != null) {
      this.dataSource = options.map((item) => ({
        // id: item.id,
        // label: item.labelname,
        picklistlabel: item.label,
        picklistname: item.value,
        funnelstage: item.funnelstage,
        // defaultpicklist: Boolean(item.defaultpicklist),
        defaultpicklist:
          item.defaultpicklist === "false"
            ? false
            : Boolean(item.defaultpicklist),
        exclude: item.exclude === "false" ? false : Boolean(item.exclude),
        addtorecordtype:
          item.addtorecordtype === "false"
            ? false
            : Boolean(item.addtorecordtype),
        converted: item.converted === "false" ? false : Boolean(item.converted),
        closed: item.closed === "false" ? false : Boolean(item.closed)
      }));
    }

    var arrayControl = this.attributeForm.get("attributeitems") as FormArray;
    for (let c of arrayControl.controls) {
      if (c.get("attr").value == "options") {
        // c.get("value").setValue(optionValue);
        c.get("value").setValue(options);
        break;
      }
    }
  }

  createPlaceholderFromValue(pValue: any) {
    console.log("pValue", pValue);
    var placeholder = "";
    var jsonValue: string | any[];

    this.picklistOptions = pValue;
    if (pValue != null && pValue !== "") {
      this.dataSource = pValue.map((item: any) => ({
        // id: item.id,
        // label: item.labelname,
        picklistlabel: item.label,
        picklistname: item.value,
        funnelstage: item.funnelstage,
        // defaultpicklist: Boolean(item.defaultpicklist),
        defaultpicklist:
          item.defaultpicklist === "false"
            ? false
            : Boolean(item.defaultpicklist),
        exclude: item.exclude === "false" ? false : Boolean(item.exclude),
        addtorecordtype:
          item.addtorecordtype === "false"
            ? false
            : Boolean(item.addtorecordtype),
        converted: item.converted === "false" ? false : Boolean(item.converted),
        closed: item.closed === "false" ? false : Boolean(item.closed)
      }));
      // console.log(this.dataSource);
    }

    if (pValue != "") {
      // jsonValue = JSON.parse(pValue);
      jsonValue = pValue;
    }

    if (jsonValue instanceof Array) {
      for (let i = 0; i < jsonValue.length; i++) {
        placeholder = placeholder + jsonValue[i].value + "\n";
      }
    }
    return placeholder;
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private appConfig: AppConfig,
    private dataService: DataService,
    private toastrService: ToastService,
    public dialog: MatDialog,
    private translationService: TranslationService,
    private sharedDataService: SharedDataService
  ) {}
  translateForm: FormGroup;
  editPicklistForm: FormGroup;
  valuePicklistForm: FormGroup;

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.metafieldId = this.route.snapshot.params.id;
      this.fieldName = this.route.snapshot.params.fieldname;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;

      this.parentobjectId = this.route.snapshot.params.parentobjectid;
      if (this.parentobjectId == "none") this.parentobjectId = "";
      this.parentobjectName = this.route.snapshot.params.parentobjectname;
      if (this.parentobjectName == "none") this.parentobjectName = "";

      this.detailForm.controls["parentobjectid"].setValue(this.parentobjectId);
      this.detailForm.controls["parentobjectname"].setValue(
        this.parentobjectId
      );

      //always convert string to boolean while assigning to formcontrol ****
      var boolValue = this.route.snapshot.params.embeddedobject == "true";
      this.embeddedObject = boolValue;
      this.detailForm.controls["embeddedobject"].setValue(this.embeddedObject);

      boolValue = this.route.snapshot.params.virtualobject == "true";
      this.virtualObject = boolValue;
      this.detailForm.controls["virtualobject"].setValue(this.virtualObject);
    });
    this.updateDisplayedColumns();

    this.valuePicklistForm = this.fb.group({
      placeholder: ["", Validators.required], // Example control for placeholder
      sortbyalphabet: false
    });

    this.getActiveObjectsByType().then((res) => {
      console.log("response11111", res);
      // console.log("parentobjects", this.parentObjects);

      //this.detailForm.controls.parentobject.patchValue('');

      // if (this.mode.toLowerCase() == "edit") {
      //   this.getMetaobjectById();
      // }
    });

    this.filterForm = this.fb.group({
      metaobjectid: "",
      metaobjectname: "",
      filteritems: this.fb.array([]),
      filtertype: "required",
      filterlogic: "",
      errormessage: "",
      lookuptext: "",
      active: true
    });

    for (let i = 0; i < this.appConfig.operatorTypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.operatorTypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.operatorList.push({
        value: this.appConfig.operatorTypes[i],
        label: strLabel
      });
    }

    for (let i = 0; i < this.appConfig.lookupfiltertypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.lookupfiltertypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.typeList.push({
        value: this.appConfig.lookupfiltertypes[i],
        label: strLabel
      });
    }

    // this.getMetaFieldsForSelection().then((res) => {
    //   console.log("response1111", res);

    //   if (this.filteritems == null) {
    //     this.addFilterItem("", "", "", "", "", "", "");
    //     this.addFilterItem("", "", "", "", "", "", "");
    //     this.addFilterItem("", "", "", "", "", "", "");
    //   } else if (this.filteritems.length == 1) {
    //     this.addFilterItem("", "", "", "", "", "", "");
    //     this.addFilterItem("", "", "", "", "", "", "");
    //   } else if (this.filteritems.length == 2) {
    //     this.addFilterItem("", "", "", "", "", "", "");
    //   }

    // });

    this.attributeForm = this.fb.group({
      fieldid: "",
      fieldname: "",
      attributeitems: this.fb.array([])
    });

    // this.applicationId = this.appConfig.defaultapplicationid;
    this.applicationId = localStorage.getItem("crm_metaapplicationid");

    this.guid = new GUID();

    console.log("mode", this.mode);

    //load field attributes definition
    this.fieldAttributesDefnJson = this.appConfig.fieldAttributes;

    //create field type picklist from fieldtypes
    for (let i = 0; i < this.appConfig.fieldTypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.fieldTypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.fieldTypeSelect.push({
        value: this.appConfig.fieldTypes[i],
        label: strLabel
      });
      this.fieldTypeSelect.sort((a, b) => a.label.localeCompare(b.label));
    }

    //create datatype list from datatypes
    for (let i = 0; i < this.appConfig.fieldDataTypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.fieldDataTypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.dataTypeSelect.push({
        value: this.appConfig.fieldDataTypes[i],
        label: strLabel
      });
    }

    this.sortOrderSelect.push({
      value: "",
      label: "--None--"
    });
    //create sortorder list from sortorder
    for (let i = 0; i < this.appConfig.sortOrderSelect.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.sortOrderSelect[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.sortOrderSelect.push({
        value: this.appConfig.sortOrderSelect[i],
        label: strLabel
      });
    }
    if (this.mode.toLowerCase() == "new") {
      //assign default field type as text
      this.detailForm.controls["fieldtype"].setValue("text");
      this.loadAttributes("text");

      this.applyRelatedToValidation("text");

      this.applyPairFieldValidation("text");

      //load profiles -> appsettings
      this.getActiveProfiles().then((res) => {
        this.profileToFormArray();
      });
    } else if (this.mode.toLowerCase() == "edit") {
      // this.getMetafieldById().then((res) => {
      // if (this.metalookupfilters.length > 0) {
      //   this.getMetaFieldsForSelection().then((res) => {
      //     console.log("response1111", res);
      //     if (this.filteritems == null) {
      //       this.addFilterItem("", "", "", "", "", "", "");
      //       this.addFilterItem("", "", "", "", "", "", "");
      //       this.addFilterItem("", "", "", "", "", "", "");
      //     } else if (this.filteritems.length == 1) {
      //       this.addFilterItem("", "", "", "", "", "", "");
      //       this.addFilterItem("", "", "", "", "", "", "");
      //     } else if (this.filteritems.length == 2) {
      //       this.addFilterItem("", "", "", "", "", "", "");
      //     }
      //   });
      // } else {
      //   this.getMetaFieldsForSelection().then((res) => {
      //     console.log("response1111", res);
      //     if (this.filteritems == null) {
      //       this.addFilterItem("", "", "", "", "", "", "");
      //       this.addFilterItem("", "", "", "", "", "", "");
      //       this.addFilterItem("", "", "", "", "", "", "");
      //     } else if (this.filteritems.length == 1) {
      //       this.addFilterItem("", "", "", "", "", "", "");
      //       this.addFilterItem("", "", "", "", "", "", "");
      //     } else if (this.filteritems.length == 2) {
      //       this.addFilterItem("", "", "", "", "", "", "");
      //     }
      //   });
      // }
      // });

      // this.getTranslationLabelById();

      //load profiles first then merge with current appsettings
      this.getActiveProfiles().then((res) => {
        this.getMetaProfileFields().then((res) => {
          this.profileToFormArray();
        });
      });
    }

    if (this.mode.toLocaleLowerCase().trim() == "new") {
      // //load fields
      this.getMetaFieldsForSelection().then((res) => {
        console.log("response1111", res);

        this.addFilterItem("", "", "", [], "", "", "", "", "");
        // this.addFilterItem("", "", "", [], "","", "");
        // this.addFilterItem("", "", "", [], "","", "");
      }); //getMetaFieldsForSelection()
    } else {
      //load queues

      this.getMetaFieldsForSelection().then((res) => {
        console.log("response1111", res);

        // load metalayout details
        this.getMetafieldById().then((res) => {
          // console.log("this.metalayout", this.metalayout);
          // console.log("this.res", res);

          //assign metalayout detail data

          if (this.filteritems == null) {
            this.addFilterItem("", "", "", "", "", "", "", "", "");
            this.addFilterItem("", "", "", "", "", "", "", "", "");
            this.addFilterItem("", "", "", "", "", "", "", "", "");
          } else if (this.filteritems.length == 1) {
            this.addFilterItem("", "", "", "", "", "", "", "", "");
            this.addFilterItem("", "", "", "", "", "", "", "", "");
          } else if (this.filteritems.length == 2) {
            this.addFilterItem("", "", "", "", "", "", "", "", "");
          }
        }); //getMetaLayoutByName()

        // this.addFilterItem("", "", "", [], "", "", "", "", "");
      });
    }

    this.translateForm = this.fb.group({
      translate: this.fb.array([]),
      code: "",
      language: ""
    });

    // Initialize with one language by default
    this.addLang();
    this.getLanguage();
    this.getTranslationLabelById();
  }

  applyPairFieldValidation(fieldType: string) {
    if (!this.attributeForm) return;

    const arrayControl = this.attributeForm.get("attributeitems") as FormArray;
    if (!arrayControl) return;

    let pairCtrl = null;

    for (let c of arrayControl.controls) {
      if (c.get("attr") && c.get("attr").value === "pairfieldname") {
        pairCtrl = c.get("value");
        break;
      }
    }

    if (!pairCtrl) return;

    if (fieldType === "mlookup") {
      pairCtrl.setValidators([Validators.required]);
    } else {
      pairCtrl.clearValidators();
    }

    pairCtrl.updateValueAndValidity();
  }

  // translateForm = this.fb.group({
  //   // label: "",
  //   label: new FormControl({value: '', disabled: true}, Validators.required),
  //   translatedlabel: "",
  //   name: "",
  //   folder: "",
  //   folderid: "",
  //   foldername: "",
  // });
  // isEditMode: boolean = false;

  // toggleEditMode() {
  //   this.mode = !this.mode;
  // }

  FieldSelection(field: any) {
    field.selected = !field.selected;
  }
  FieldDeSelection(field: any) {
    field.selected = !field.selected;
  }
  moveSelectedFieldsToDone() {
    const selectedFields = this.compliancesToDo.filter(
      (field) => field.selected
    );
    this.compliancesDone.push(...selectedFields);
    this.compliancesToDo = this.compliancesToDo.filter(
      (field) => !field.selected
    );
    selectedFields.forEach((field) => (field.selected = false));
    console.log(this.compliancesDone);
  }

  moveSelectedFieldsToDo() {
    const selectedFields = this.compliancesDone.filter(
      (field) => field.selected
    );
    this.compliancesToDo.push(...selectedFields);
    this.compliancesDone = this.compliancesDone.filter(
      (field) => !field.selected
    );
    selectedFields.forEach((field) => (field.selected = false));
    console.log(this.compliancesDone);
  }

  getDefaultCriteria() {
    var arrDefaultCriteria = [];

    //default criteria deleted equals false
    var fieldsFilter = this.fields.filter(function (field) {
      return (
        field.fieldname.toLowerCase().trim() == "deleted" ||
        (field.metaobjectname.toLowerCase().trim() == "lead" &&
          field.fieldname.toLowerCase().trim() == "converted")
      );
    });

    console.log("fieldsFilter***deleted", fieldsFilter);

    for (let fld of fieldsFilter) {
      var metaProfileLayoutCriteria = {
        id: this.guid.getGUID("metaprofilelayoutcriteria"),
        metaobjectid: this.metaobjectId,
        // metalayoutid: this.metalayoutId,
        metafieldid: fld.id,
        fieldname: fld.fieldname,
        fieldtype: fld.fieldtype,
        operator: "equals",
        value: false,
        filterlogic: "AND"
      };

      arrDefaultCriteria.push(metaProfileLayoutCriteria);
    }

    return arrDefaultCriteria;
  }

  createMetaProfileLayoutCriteria() {
    //get criteria details and assign it to postoption
    //get formarray details
    var arrMetaProfileLayoutCriteria = this.getDefaultCriteria();

    var arrayControl = this.filterForm.get("filteritems") as FormArray;
    for (let c of arrayControl.controls) {
      var fieldId = c.get("fieldid").value;
      var fieldName = c.get("fieldname").value;
      var fieldType = c.get("fieldtype").value;
      var metaObjName = c.get("metaobjectname").value;

      var operator = c.get("fieldoperator").value;
      if (operator.toLowerCase().trim() == "--none--") operator = "";

      var value = c.get("fieldvalue").value;
      // if (value.toLowerCase().trim() == "--none--") value = "";
      if (value == "--none--") value = "";

      if (fieldId != "" && operator != "") {
        var metaProfileLayoutCriteria = {
          id: this.guid.getGUID("metaprofilelayoutcriteria"),
          metaobjectid: this.metaobjectId,
          // metalayoutid: this.metalayoutId,
          metafieldid: fieldId,
          fieldname: fieldName,
          fieldtype: fieldType,
          operator: operator,
          value: value,
          filterlogic: c.get("filterlogic").value
        };

        //push it to array
        arrMetaProfileLayoutCriteria.push(metaProfileLayoutCriteria);
      }
    }

    return arrMetaProfileLayoutCriteria;
  }
  getLanguage() {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );

    this.isLoading = true;
    this.dataService
      .getOrgLanguage(organizationid, domain, subdomain)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res !== null && res.success == 1) {
            var allLanguages = res.data.orglanguage;
            var objArr = [];
            //just add an empty entry sice this field is optional
            objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < allLanguages.length; i++) {
              objArr.push({
                value: allLanguages[i].code,
                label: allLanguages[i].language
              });
            }
            this.languages = objArr;

            this.isLoading = false;
          } else {
            console.log("error while deleting");
            this.isLoading = false;
            this.showError(res.message);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          this.showError(err.message);
        }
      );
  }

  selectedLanguageChange(event: { value: string; label: any }) {
    console.log("selectedLanguageChange", event);
    if (event.value.trim() != "") {
      this.translateForm.controls["code"].setValue(event.value);
      this.translateForm.controls["language"].setValue(event.label);
    } else {
      this.translateForm.controls["code"].setValue("");
      this.translateForm.controls["language"].setValue("");
    }
  }
  // languages: string[] = ["English", "es", "French", "German"];
  // selectedLanguage: string = "es";
  translatedText: string = "";

  // translateForm = new FormGroup({
  //   translate: new FormArray([
  //     new FormGroup({
  //       selectedLanguage: new FormControl(""),
  //       translatedText: new FormControl(""),
  //       // number: new FormControl(''),
  //       // email: new FormControl('')
  //     }),
  //   ]),

  // });

  translatingDialog(labelname: any): void {
    console.log("labelname", labelname);

    if (!labelname) {
      return;
    }

    this.translateForm.patchValue({ label: labelname });
    this.data = {
      labelname: labelname
    };

    this.dialogRef = this.dialog.open(this.translateDialog, {
      data: this.data,
      height: "400px",
      width: "800px"
    });

    this.dialogRef.afterClosed().subscribe((result: any) => {
      console.log("The dialog was closed.");
      if (result) {
      }
    });
  }

  get translate(): FormArray {
    return this.translateForm.get("translate") as FormArray;
  }

  addLang() {
    const translateGroup = this.fb.group({
      languageCode: ["", Validators.required],
      translatedName: ["", Validators.required]
    });

    this.translate.push(translateGroup);
  }

  // translator() {
  //   const selectedLanguage =
  //     this.translateForm.value.translate[0].selectedLanguage;
  //   const labelname = this.data.labelname;
  //   console.log(selectedLanguage);
  //   console.log(this.translateForm.value.translate);
  //   this.translationService
  //     .translate(labelname, selectedLanguage)
  //     .subscribe((response: any) => {
  //       this.translatedText = response.data.translations[0].translatedText;
  //     });
  // }
  translator(index: number) {
    const translateGroup = this.translate.at(index) as FormGroup;
    const selectedLanguage = translateGroup.get("languageCode").value;
    const labelname = this.data.labelname;

    console.log(selectedLanguage);

    this.translationService
      .translate(labelname, selectedLanguage, "en")
      .subscribe((response: any) => {
        const translatedText = response.data.translations[0].translatedText;
        translateGroup.get("translatedName").setValue(translatedText);
      });
  }
  saveTranslated() {
    // console.log(this.translateForm);
    if (this.translateForm.valid) {
      // Handle the form submission
      console.log("Saving form data:", this.translateForm.value.translate);

      this.translatedLabels = this.translateForm.value.translate;
    }
    this.dialogRef.close();
  }
  removeLang(index: number) {
    this.translate.removeAt(index);
  }

  close() {
    this.dialogRef.close();
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark"
    };
    this.toastrService.warning(data, "", options);
  }

  metaobjectDetail() {
    this.router.navigateByUrl(
      "home/metaobjectdetail/" + this.metaobjectId + "/" + this.metaobjectName
    );
  }

  // fieldTypeChange(event: { value: string }) {
  //   console.log("fieldTypeChange", event);
  //   if (event.value.trim() != "") {
  //     var attrType = this.getAttributeType(event.value);
  //     this.loadAttributes(attrType);
  //     this.applyRelatedToValidation(fieldType);
  //   }

  //   var fldtype = event.value.toLocaleLowerCase().trim();
  //   var arrayControl = this.attributeForm.get("attributeitems") as FormArray;
  //   for (let c of arrayControl.controls) {
  //     // console.log(c);
  //     //disable datatype field if selected fieldtype is picklist,id,checkbox,currency,double,timestamp
  //     if (
  //       fldtype == "picklist" ||
  //       fldtype == "id" ||
  //       fldtype == "checkbox" ||
  //       fldtype == "currency" ||
  //       // fldtype == 'double' || fldtype == 'timestamp'){
  //       fldtype == "double"
  //     ) {
  //       if (c.get("attr").value == "datatype") {
  //         c.disable();
  //       }
  //     }
  //     if (
  //       fldtype == "lookup" ||
  //       fldtype == "masterdetail" ||
  //       fldtype == "map"
  //     ) {
  //       this.showFilterForm = true;
  //     } else {
  //       this.showFilterForm = false;
  //     }

  //     //set default length and disable for fieldtype id,picklist,checkbox,lookup,dropdown,date,timestamp
  //     if (fldtype == "id") {
  //       if (c.get("attr").value == "length") {
  //         c.get("value").setValue("20");
  //         c.disable();
  //       }
  //     } else if (fldtype == "picklist") {
  //       if (c.get("attr").value == "length") {
  //         c.get("value").setValue("40");
  //         c.disable();
  //       }
  //     } else if (
  //       fldtype == "checkbox" ||
  //       fldtype == "lookup" ||
  //       fldtype == "dropdown" ||
  //       fldtype == "date" ||
  //       fldtype == "timestamp" ||
  //       fldtype == "photo" ||
  //       fldtype == "imageupload" ||
  //       fldtype == "socialmedia" ||
  //       fldtype == "map" ||
  //       fldtype == "radio" ||
  //       fldtype == "masterdetail"
  //     ) {
  //       if (c.get("attr").value == "length") {
  //         c.disable();
  //       }
  //     }
  //   }
  // }

  // fieldTypeChange(event: { value: string }) {
  //   var fieldType = this.detailForm.get("fieldtype").value;

  //   if (fieldType) {
  //     fieldType = fieldType.toLowerCase().trim();
  //     this.applyRelatedToValidation(fieldType);
  //     this.applyPairFieldValidation(fieldType);
  //   }
  // }

  fieldTypeChange(event: { value: string }) {
    const fieldType = event.value.toLowerCase().trim();

    if (!fieldType) {
      return;
    }

    const attrType = this.getAttributeType(fieldType);

    // முதலில் attributes load ஆகணும்
    this.loadAttributes(attrType);

    // அப்புறம் validator apply ஆகணும்
    this.applyRelatedToValidation(fieldType);
    this.applyPairFieldValidation(fieldType);
  }

  getAttributeType(fieldType: string) {
    var attrType = "";
    if (fieldType != "") {
      if (
        fieldType == "text" ||
        fieldType == "textarea" ||
        fieldType == "longtext"
      ) {
        attrType = "text";
      } else if (fieldType == "formulatext") {
        attrType = "formulatext";
      } else if (fieldType == "date") {
        attrType = "date";
      } else if (fieldType == "timestamp") {
        attrType = "timestamp";
      } else if (
        fieldType == "double" ||
        fieldType == "currency" ||
        fieldType == "percentage"
      ) {
        attrType = "double";
      } else if (fieldType == "checkbox") {
        attrType = "boolean";
      } else if (fieldType == "number") {
        attrType = "int";
      } else {
        attrType = fieldType;
      }
    }
    return attrType;
  }

  // applyRelatedToValidation(fieldType: string) {
  //   console.log("fieldType =", fieldType);
  //   const arrayControl = this.attributeForm.get("attributeitems") as FormArray;

  //   const relatedItem = arrayControl.controls.find((c) => {
  //     return c.get("attr") && c.get("attr").value === "relatedto";
  //   });

  //   console.log("relatedItem =", relatedItem);
  //   console.log("relatedItem", relatedItem);
  //   if (!relatedItem) return;

  //   const relatedCtrl = relatedItem.get("value") as FormControl;

  //   if (this.relatedToRequiredTypes.includes(fieldType)) {
  //     relatedCtrl.setValidators([Validators.required]);
  //   } else {
  //     relatedCtrl.clearValidators();
  //   }

  //   relatedCtrl.updateValueAndValidity();
  // }

  applyRelatedToValidation(fieldType: string) {
    console.log("fieldType =", fieldType);

    const arrayControl = this.attributeForm.get("attributeitems") as FormArray;

    const relatedItem = arrayControl.controls.find(
      (c) => c.get("attr").value === "relatedto"
    );

    console.log("relatedItem =", relatedItem);

    if (!relatedItem) {
      console.log("relatedto control not found");
      return;
    }

    const relatedCtrl = relatedItem.get("value") as FormControl;

    if (this.relatedToRequiredTypes.includes(fieldType)) {
      console.log("Required validator applied");
      relatedCtrl.setValidators([Validators.required]);
    } else {
      console.log("Validator cleared");
      relatedCtrl.clearValidators();
    }

    relatedCtrl.updateValueAndValidity();

    console.log("errors =", relatedCtrl.errors);
  }
  loadAttributes(attrType: string) {
    if (attrType != "") {
      this.fieldAttributeArray = this.fieldAttributesDefnJson[attrType];
      if (this.attributeitems != undefined) this.attributeitems.clear();
      console.log(this.fieldAttributesDefnJson);
      console.log(this.fieldAttributeArray);
      //create new formarry for field attributes
      var fgArray = new Array<FormGroup>();
      //transform json to attribute form controls
      for (let i = 0; i < this.fieldAttributeArray.length; i++) {
        var item = this.fieldAttributeArray[i];
        if (this.mode.toLocaleLowerCase() == "new") {
          if (item.attr.toLowerCase() === "relationvisibility") {
            this.addAttributeItem(
              item.attr,
              item.type,
              "global",
              "",
              item.hint
            );
          } else if (item.type.toLocaleLowerCase() == "boolean") {
            this.addAttributeItem(item.attr, item.type, false, "", item.hint);
          } else if (item.attr.toLowerCase() == "length") {
            const fieldType = this.detailForm
              .get("fieldtype")
              .value.toLowerCase();

            let defaultLength: number = 0;

            switch (fieldType) {
              case "text":
                defaultLength = 60;
                break;

              case "textarea":
                defaultLength = 255;
                break;

              case "lookup":
                defaultLength = 50;
                break;

              case "number":
                defaultLength = 10;
                break;

              default:
                defaultLength = 0;
            }

            this.addAttributeItem(
              item.attr,
              item.type,
              defaultLength,
              "",
              item.hint
            );
          } else if (item.type.toLocaleLowerCase() == "number") {
            this.addAttributeItem(item.attr, item.type, 3, "", item.hint);
          } else {
            this.addAttributeItem(item.attr, item.type, "", "", item.hint);
          }
        } else if (this.mode.toLocaleLowerCase() == "edit") {
          //get value from the attributes
          var value = this.metafield.attributes[item.attr];
          if (value instanceof Array) {
            value = JSON.stringify(value);
          }

          if (item.type.toLocaleLowerCase() == "number") {
            value = Number(value); // Convert to number
          }
          this.addAttributeItem(item.attr, item.type, value, "", item.hint);
        }
      }

      var arrayControl = this.attributeForm.get("attributeitems") as FormArray;
      for (let c of arrayControl.controls) {
        console.log(c);
        if (c.get("attr").value == "datatype") {
          c.get("value").setValue(attrType);
          break;
        }
      }
    }
    const fieldType = this.detailForm.get("fieldtype").value;

    if (fieldType) {
      this.applyRelatedToValidation(fieldType.toLowerCase().trim());
      this.applyPairFieldValidation(fieldType.toLowerCase().trim());
    }
  }

  getMetafieldById() {
    return new Promise((resolve, reject) => {
      console.log("getActiveProfiles");
      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metafield: {
            id: this.metafieldId
          }
        }
      };

      this.isLoading = true;
      this.dataService.getMetafieldById(postOption).subscribe(
        (res) => {
          //alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            this.metafield = res.data.metafield;
            if (this.metafield != null) {
              if (
                this.metafield.fieldtype == "lookup" ||
                this.metafield.fieldtype == "masterdetail"
              ) {
                this.showFilterForm = true;
              } else {
                this.showFilterForm = false;
              }
              this.labelName = this.metafield.labelname;
              this.metaobjectId = this.metafield.metaobjectid;
              this.metaobjectName = this.metafield.metaobjectname;

              this.detailForm.controls["metaobjectid"].setValue(
                this.metafield.metaobjectid
              );
              this.detailForm.controls["metaobjectname"].setValue(
                this.metafield.metaobjectname
              );
              this.detailForm.controls["id"].setValue(this.metafield.id);
              this.detailForm.controls["labelname"].setValue(
                this.metafield.labelname
              );
              this.detailForm.controls["fieldname"].setValue(
                this.metafield.fieldname
              );
              this.detailForm.controls["fieldtype"].setValue(
                this.metafield.fieldtype
              );

              this.applyPairFieldValidation(
                this.metafield.fieldtype.toLowerCase()
              );

              this.detailForm.controls["standard"].setValue(
                this.metafield.standard
              );
              this.detailForm.controls["primaryfield"].setValue(
                this.metafield.primaryfield
              );
              this.detailForm.controls["required"].setValue(
                this.metafield.required
              );
              this.detailForm.controls["tenantfield"].setValue(
                this.metafield.tenantfield || false
              );
              this.detailForm.controls["defaultvalue"].setValue(
                this.metafield.defaultvalue
              );
              this.detailForm.controls["parentobjectid"].setValue(
                this.metafield.parentobjectid
              );
              this.detailForm.controls["parentobjectname"].setValue(
                this.metafield.parentobjectname
              );
              this.detailForm.controls["description"].setValue(
                this.metafield.description
              );
              this.detailForm.controls["hinttext"].setValue(
                this.metafield.hinttext || ""
              );
              this.detailForm.controls["helptext"].setValue(
                this.metafield.helptext || ""
              );
              this.detailForm.controls["embeddedobject"].setValue(
                this.metafield.embeddedobject
              );
              this.detailForm.controls["virtualobject"].setValue(
                this.metafield.virtualobject
              );
              this.detailForm.controls["active"].setValue(
                this.metafield.active
              );
              this.detailForm.controls["attributes"].setValue(
                this.metafield.attributes
              );

              this.fieldUsageForm.controls["fieldusage"].setValue(
                this.metafield.fieldusage
              );
              this.fieldUsageForm.controls["sensitivitylevel"].setValue(
                this.metafield.datasensitivitylevel
              );
              // this.detailForm.controls["sinceversionseq"].setValue(
              //   this.metafield.sinceversionseq != null
              //     ? this.metafield.sinceversionseq
              //     : 0
              // );

              // this.detailForm.controls["deprecatedversionseq"].setValue(
              //   this.metafield.deprecatedversionseq != null
              //     ? this.metafield.deprecatedversionseq
              //     : 0
              // );
              this.detailForm.controls["sinceversionseq"].setValue(
                this.metafield.sinceversionseq != null
                  ? this.metafield.sinceversionseq
                  : 0
              );

              this.detailForm.controls["deprecatedversionseq"].setValue(
                this.metafield.deprecatedversionseq != null
                  ? this.metafield.deprecatedversionseq
                  : 0
              );

              // this.fieldUsageForm.controls["fieldusage"].setValue(
              //   this.metafield.fieldusage
              // );

              if (this.metafield.compliancecategorization != null) {
                const values =
                  this.metafield.compliancecategorization.split(",");

                console.log(values);

                this.compliancesDone = values.map((value) => ({
                  value: value,
                  label: value,
                  selected: false
                }));
                this.filterCompliancesToDo();
                console.log(this.compliancesDone);
              }

              this.modifiedby = this.metafield.modifiedby;
              this.modifieddate = this.metafield.modifieddate;

              this.fieldAttributeArray =
                this.fieldAttributesDefnJson[this.metafield.fieldtype];
              console.log("attributes", this.metafield.attributes);

              this.relatedToObject = this.metafield.attributes.relatedto;

              var fgArray = new Array<FormGroup>();
              //transform json to attribute form controls
              for (let i = 0; i < this.fieldAttributeArray.length; i++) {
                var item = this.fieldAttributeArray[i];

                if (item.attr.toLowerCase() == "picklisttype") {
                  this.picklistType = this.metafield.attributes[item.attr];
                }

                var placeholder = "";
                if (item.attr.toLowerCase() == "options") {
                  // if(item.attr.toLowerCase() == "picklisttype")
                  console.log(this.metafield.attributes[item.attr]);

                  if (
                    Array.isArray(this.metafield.attributes[item.attr]) &&
                    this.metafield.attributes[item.attr].length > 0
                  ) {
                    placeholder = this.createPlaceholderFromValue(
                      this.metafield.attributes[item.attr]
                    );

                    const picklistValuesString = this.metafield.attributes[
                      item.attr
                    ]
                      .map((item: any) => item.value)
                      .join("\n");
                    this.valuePicklistForm.controls["placeholder"].setValue(
                      picklistValuesString
                    );

                    this.valuePicklistForm.controls["sortbyalphabet"].setValue(
                      this.metafield.attributes[item.attr][0].sortbyalphabet
                    );
                  }
                }

                //get value from the attributes
                var value = this.metafield.attributes[item.attr];
                if (value instanceof Array) {
                  value = JSON.stringify(value);
                  console.log(value);
                }
                console.log(item.type);
                if (item.type.toLocaleLowerCase() == "number") {
                  value = Number(value); // Convert to number

                  console.log("*********", value);
                }

                this.addAttributeItem(
                  item.attr,
                  item.type,
                  value,
                  placeholder,
                  item.hint
                );
              }
            }

            this.metalookupfilters = res.data.metalookupfilters;
            this.getLookupObjectFields().then(() => {});
            // this.getLookupObjectFields().then(() => {
            //   console.log("Lookup object fields loaded: ", this.fields);
            // });

            if (
              this.metalookupfilters != null &&
              this.metalookupfilters.length > 0
            ) {
              // this.metaobjectId = this.metafield.metaobjectid;
              // this.metaobjectName = this.metafield.metaobjectname;

              this.filterForm.controls["errormessage"].setValue(
                this.metalookupfilters[0].errormessage
              );
              this.filterForm.controls["active"].setValue(
                this.metalookupfilters[0].active
              );
              this.filterForm.controls["filtertype"].setValue(
                this.metalookupfilters[0].filtertype
              );
              this.filterForm.controls["lookuptext"].setValue(
                this.metalookupfilters[0].lookuptext
              );
              this.filterForm.controls["filterlogic"].setValue(
                this.metalookupfilters[0].filterlogic
              );

              var criterias = this.metalookupfilters;
              var index = 0;
              for (let i = 0; i < criterias.length; i++) {
                let criteria = criterias[i];

                console.log("fieldname", criteria.filterfieldname);
                console.log(criteria.filterfieldid);

                //skip id type fields if there
                if (criteria.filterfieldname.toLowerCase() == "deleted") {
                  console.log("deleted found.");
                  continue;
                }
                //skip converted field if object is lead
                if (
                  this.metaobjectName.toLowerCase().trim() == "lead" &&
                  criteria.filterfieldname.toLowerCase() == "converted"
                ) {
                  console.log("converted found.");
                  continue;
                }

                //get addnl field detail from fields
                var fldName = "";
                var fldLabel = "";
                var fldType = "";
                var fldOptions: string;
                var metaObjName = "";
                var filterValue: any;

                this.getLookupObjectFields().then(() => {
                  console.log("Lookup object fields loaded: ", this.fields);
                  // console.log(this.fields);
                  console.log(criteria.filterfieldid);

                  for (let j = 0; j < this.fields.length; j++) {
                    if (this.fields[j].id == criteria.filterfieldid) {
                      console.log(this.fields[j]);
                      fldName = this.fields[j].fieldname;
                      //convert to titecase
                      fldLabel = this.fields[j].labelname;
                      fldLabel = fldLabel[0].toUpperCase() + fldLabel.slice(1);
                      fldType = this.fields[j].fieldtype;
                      metaObjName = this.fields[j].metaobjectname;

                      console.log(this.fields[j].fieldtype);

                      if (this.fields[j].options != null) {
                        fldOptions = this.fields[j].options;
                      }
                      console.log("fldOptions", fldOptions);
                      break;
                    }
                  }

                  if (criteria.filterfieldtype == "checkbox") {
                    filterValue = Boolean(criteria.value);
                  } else {
                    filterValue = criteria.value;
                  }
                  //add item
                  console.log("criteria.", criteria);
                  console.log("criteria.filterfieldid", criteria.filterfieldid);
                  console.log("criteria.fldName", fldName);
                  console.log("criteria.fldType", fldType);
                  console.log("criteria.operator", criteria.operator);
                  console.log("criteria.type", criteria.type);
                  console.log("criteria.metaobjectname", metaObjName);
                  console.log("criteria.value", criteria.value);

                  this.addFilterItem(
                    criteria.filterfieldid,
                    fldName || criteria.filterfieldname,
                    fldType || criteria.filterfieldtype,
                    fldOptions,
                    criteria.operator,
                    criteria.type,
                    // criteria.value,
                    filterValue,
                    criteria.filterlogic,
                    metaObjName
                  );
                  console.log(fldOptions);
                  if (fldOptions != null) {
                    var arr = JSON.parse(fldOptions);
                    this.picklistValueList[index] = arr;
                  }

                  index++;
                });
              }
              // ).catch((error) => {
              //     console.error("Error loading lookup object fields:", error);
              //   });

              // var i = 0;
              // var arrayControl = this.filterForm.get(
              //   "filteritems"
              // ) as FormArray;
              // for (let c of arrayControl.controls) {
              //   for (var filterItem of this.metalookupfilters) {
              //     console.log("matching", c);
              //     c.get("fieldid").setValue(filterItem.filterfieldid);
              //     c.get("fieldtype").setValue(filterItem.filterfieldtype);
              //     c.get("fieldname").setValue(filterItem.filterfieldname);
              //     c.get("operator").setValue(filterItem.operator);
              //     c.get("filterlogic").setValue(filterItem.filterlogic);
              //   }
              // }

              // this.detailForm.controls["fieldname"].setValue(
              //   this.metafield.fieldname
              // );
              // this.detailForm.controls["fieldtype"].setValue(
              //   this.metafield.fieldtype
              // );
              // this.detailForm.controls["standard"].setValue(
              //   this.metafield.standard
              // );
              // this.detailForm.controls["primaryfield"].setValue(
              //   this.metafield.primaryfield
              // );
              // this.detailForm.controls["required"].setValue(
              //   this.metafield.required
              // );
              // this.detailForm.controls["tenantfield"].setValue(
              //   this.metafield.tenantfield
              // );
              // this.detailForm.controls["defaultvalue"].setValue(
              //   this.metafield.defaultvalue
              // );
              // this.detailForm.controls["parentobjectid"].setValue(
              //   this.metafield.parentobjectid
              // );
              // this.detailForm.controls["parentobjectname"].setValue(
              //   this.metafield.parentobjectname
              // );
              // this.detailForm.controls["description"].setValue(
              //   this.metafield.description
              // );
              // this.detailForm.controls["embeddedobject"].setValue(
              //   this.metafield.embeddedobject
              // );
              // this.detailForm.controls["virtualobject"].setValue(
              //   this.metafield.virtualobject
              // );
              // this.detailForm.controls["active"].setValue(this.metafield.active);
              // this.detailForm.controls["attributes"].setValue(
              //   this.metafield.attributes
              // );

              // this.fieldAttributeArray =
              //   this.fieldAttributesDefnJson[this.metafield.fieldtype];
              // console.log("attributes", this.metafield.attributes);

              // var fgArray = new Array<FormGroup>();
              // //transform json to attribute form controls
              // for (let i = 0; i < this.fieldAttributeArray.length; i++) {
              //   var item = this.fieldAttributeArray[i];

              //   var placeholder = "";
              //   if (item.attr.toLowerCase() == "options") {
              //     placeholder = this.createPlaceholderFromValue(
              //       this.metafield.attributes[item.attr]
              //     );
              //   }

              //   //get value from the attributes
              //   var value = this.metafield.attributes[item.attr];
              //   if (value instanceof Array) {
              //     value = JSON.stringify(value);
              //   }
              //   this.addAttributeItem(item.attr, item.type, value, placeholder);
              // }
            } else {
              this.addFilterItem("", "", "", [], "", "", "", "", "");
            }

            this.isLoading = false;
          } else {
            console.log("no data");
            this.isLoading = false;
            //this.resetDetailFormControls();
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          //this.resetDetailFormControls();
        }
      );
    });
  }

  filterCompliancesToDo() {
    const doneLabels = this.compliancesDone.map((field) => field.label);
    this.compliancesToDo = this.compliancesToDo.filter(
      (field) => !doneLabels.includes(field.label)
    );
  }

  getTranslationLabelById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        metafieldlabeltranslation: {
          metafieldid: this.metafieldId
        }
      }
    };

    this.isLoading = true;
    this.dataService.getTranslationLabelById(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          // Loop through the response and add translation fields
          if (res.data.metafieldlabeltranslation) {
            this.translate.clear();
            res.data.metafieldlabeltranslation.forEach((translation) => {
              const translateGroup = this.fb.group({
                languageCode: [translation.languagecode, Validators.required],
                translatedName: [
                  translation.translatedlabel,
                  Validators.required
                ]
              });
              this.translate.push(translateGroup);
            });
            // After populating translateForm, update translatedLabels
            this.translatedLabels = res.data.metafieldlabeltranslation.map(
              (translation) => ({
                languageCode: translation.languagecode,
                translatedName: translation.translatedlabel
              })
            );
          }
          this.isLoading = false;
        } else {
          console.log("no data");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        //this.resetDetailFormControls();
      }
    );
  }

  getActiveProfiles() {
    return new Promise((resolve, reject) => {
      console.log("getActiveProfiles");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          profile: {
            userlicense: localStorage.getItem("crm_userlicense")
          }
        }
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveProfileByUserLicense(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.profiles = res.data.profiles;
            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No profile data!");
            this.errorMessage = res != null ? res.message : "No profile data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getMetaProfileFields() {
    return new Promise((resolve, reject) => {
      console.log("getMetaProfileFields");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metaprofilefield: {
            metafieldid: this.metafieldId
          }
        }
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getMetaProfileFields(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res.success == 1) {
            this.metaProfileFieldJSON = res.data.metaprofilefields;
            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metaprofilefield data!");
            this.errorMessage =
              res != null ? res.message : "No metaprofilefield data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }
  getMetaFieldsForSelection() {
    return new Promise((resolve, reject) => {
      console.log("getMetaFieldsForSelection");

      var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        profileid: userDetail.profileid,
        data: {
          metafield: {
            metaobjectid: this.metaobjectId,
            metaobjectname: this.metaobjectName
          }
        }
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getMetaFieldsForSelection(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.fields = res.data.metafields;

            //add default --None-- into field list
            this.fieldList.push({
              value: "--None--",
              label: "--None--",
              fieldtype: "text",
              standard: true,
              options: [],
              id: "",
              metaobjectname: ""
            });

            this.sortBySelect.push({
              value: "--None--",
              label: "--None--"
            });

            //create fieldlist from fields as readable form by selection control
            for (let i = 0; i < this.fields.length; i++) {
              var field = this.fields[i];

              //skip id type fields if there
              if (field.fieldtype.toLowerCase() == "id") continue;

              //skip fields with visibility false
              if (field.visible == false) continue;

              //skip fields deleted, ownertype etc.,
              if (
                field.fieldname.toLowerCase() == "deleted" ||
                field.fieldname.toLowerCase() == "ownertype" ||
                field.fieldname.toLowerCase() == "migrated" ||
                field.fieldname.toLowerCase() == "organizationid" ||
                field.fieldname.toLowerCase() == "search" ||
                field.fieldname.toLowerCase() == "date_range"
              )
                continue;

              //skip converted field if object is lead
              if (
                this.metaobjectName.toLowerCase().trim() == "lead" &&
                field.fieldname.toLowerCase() == "converted"
              )
                continue;

              //convert to titecase
              var strLabel = field.labelname;
              var formattedLabel = field.metaobjectname + ": " + strLabel;

              strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);

              this.fieldList.push({
                // value: field.fieldname,
                value: field.id,
                // label: strLabel,
                label: formattedLabel,
                fieldtype: field.fieldtype,
                standard: field.standard,
                options: field.options,
                // id: field.id,
                id: field.fieldname,
                metaobjectname: field.metaobjectname
              });

              this.sortBySelect.push({
                // value: field.fieldname,
                value: field.fieldname,
                // label: strLabel,
                label: formattedLabel
              });

              // console.log(this.fieldList);
            }

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No fields data!");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getLookupObjectFields() {
    return new Promise((resolve, reject) => {
      console.log("getLookupObjectFields");

      var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        profileid: userDetail.profileid,
        data: {
          metafield: {
            // metaobjectid: this.metaobjectId,
            metaobjectname: this.relatedToObject
            // metaobjectname: "Class",
          }
        }
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getMetaFieldsForSelection(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.fields = res.data.metafields;

            //create fieldlist from fields as readable form by selection control
            for (let i = 0; i < this.fields.length; i++) {
              var field = this.fields[i];

              //skip id type fields if there
              if (field.fieldtype.toLowerCase() == "id") continue;

              //skip fields with visibility false
              if (field.visible == false) continue;

              //skip fields deleted, ownertype etc.,
              if (
                field.fieldname.toLowerCase() == "deleted" ||
                field.fieldname.toLowerCase() == "ownertype" ||
                field.fieldname.toLowerCase() == "migrated" ||
                field.fieldname.toLowerCase() == "organizationid" ||
                field.fieldname.toLowerCase() == "search" ||
                field.fieldname.toLowerCase() == "date_range"
              )
                continue;

              //skip converted field if object is lead
              if (
                this.metaobjectName.toLowerCase().trim() == "lead" &&
                field.fieldname.toLowerCase() == "converted"
              )
                continue;

              //convert to titecase
              // var strLabel = field.labelname;
              var strLabel = field.labelname;
              var formattedLabel = field.metaobjectname + ": " + strLabel;

              strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
              this.fieldList.push({
                // value: field.fieldname,
                value: field.id,
                // label: strLabel,
                label: formattedLabel,
                fieldtype: field.fieldtype,
                standard: field.standard,
                options: field.options,
                // id: field.id,
                id: field.fieldname,
                metaobjectname: field.metaobjectname
              });
              this.sortBySelect.push({
                // value: field.fieldname,
                value: field.fieldname,
                // label: strLabel,
                label: formattedLabel
              });

              this.sortBySelect = [...this.sortBySelect];

              // console.log(this.sortBySelect);
            }

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No fields data!");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getActiveObjectsByType() {
    return new Promise((resolve, reject) => {
      console.log("getActiveObjectsByType");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metaobject: {
            objecttype: "Domain"
          }
        }
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveObjectsByType(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            var activeObjects = res.data.metaobjects;

            console.log("Active Objects:", activeObjects);
            var objArr = [];
            //just add an empty entry sice this field is optional
            objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < activeObjects.length; i++) {
              objArr.push({
                value: activeObjects[i].name,
                label: activeObjects[i].name
              });
            }
            objArr.push(...this.defaultObj);

            this.relatedToSelect = objArr;

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metaobject data!");
            this.errorMessage =
              res != null ? res.message : "No metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  profileToFormArray() {
    console.log("profileToFormArray");

    console.log(this.profiles);

    if (this.profiles == null || this.profiles.length == 0) return;

    let metaProfileFieldsArray = [];
    for (let i = 0; i < this.profiles.length; i++) {
      {
        var profile = this.profiles[i];
        var metaProfileField = {
          id: "", //new id to be generated later
          organizationid: profile.organizationid,
          metaobjectid: this.metaobjectId,
          parentobjectid: this.parentobjectId,
          embeddedobject: this.embeddedObject,
          metafieldid: "", //to be assigned later while saving the new app
          profileid: profile.id,
          profilename: profile.name,
          visible: true,
          readonly: false
        };
        metaProfileFieldsArray.push(metaProfileField);
      }
    }

    //merge profile and metaprofilefield on edit mode
    if (
      metaProfileFieldsArray.length > 0 &&
      this.mode.toLocaleLowerCase() == "edit"
    ) {
      for (let i = 0; i < metaProfileFieldsArray.length; i++) {
        //compare with the existing metaprofilefield loaded for this application
        for (let j = 0; j < this.metaProfileFieldJSON.length; j++) {
          var item = this.metaProfileFieldJSON[j];

          //compare matching profile
          if (metaProfileFieldsArray[i].profileid == item.profileid) {
            metaProfileFieldsArray[i].id = item.id;
            metaProfileFieldsArray[i].visible = item.visible;
            metaProfileFieldsArray[i].readonly = item.readonly;
            break;
          }
        }
      }
    }

    //now create FormArray from the list

    //convert profile to metaprofilefield formarray
    if (metaProfileFieldsArray != null) {
      //transform json to form controls
      for (let i = 0; i < metaProfileFieldsArray.length; i++) {
        var metapf = metaProfileFieldsArray[i];

        var fg = new FormGroup({
          id: new FormControl(metapf.id),
          organizationid: new FormControl(metapf.organizationid),
          metaobjectid: new FormControl(metapf.metaobjectid),
          parentobjectid: new FormControl(metapf.parentobjectid),
          embeddedobject: new FormControl(metapf.embeddedobject),
          metafieldid: new FormControl(metapf.metafieldid),
          profileid: new FormControl(metapf.profileid),
          profilename: new FormControl(metapf.profilename),
          visible: new FormControl(metapf.visible),
          readonly: new FormControl(metapf.readonly)
        });

        this.fgsArray.push(fg);
      }

      this.profileForm.setControl(
        "metaprofilefields",
        new FormArray(this.fgsArray)
      );
    }
  }

  lookupFilterDialog(): void {
    // this.translateForm.patchValue({ label: labelname });
    // this.data = {
    //   labelname: labelname,
    // };

    this.filterdialogRef = this.dialog.open(this.filterDialog, {
      // data: this.data,
      height: "500px",
      width: "1400px",
      disableClose: true
    });

    this.filterdialogRef.afterClosed().subscribe((result: any) => {
      console.log("The dialog was closed.");
      if (result) {
      }
    });
  }

  savefilter() {
    this.filterdialogRef.close();
  }

  closefilter() {
    // this.filterForm.reset();
    this.filterdialogRef.close();
  }

  fielduseDialog(): void {
    // this.translateForm.patchValue({ label: labelname });
    // this.data = {
    //   labelname: labelname,
    // };

    this.fieldUsagedialogRef = this.dialog.open(this.fieldUsageDialog, {
      // data: this.data,
      height: "450px",
      width: "900px"
    });

    this.fieldUsagedialogRef.afterClosed().subscribe((result: any) => {
      console.log("The dialog was closed.");
      if (result) {
      }
    });
  }

  saveFieldusage() {
    this.fieldUsagedialogRef.close();
  }

  closeFieldusage() {
    // this.filterForm.reset();
    this.fieldUsagedialogRef.close();
  }

  // picklistvalueNew() {
  //   console.log("1234567890-")
  //   // this.showStandardPicklist = true;
  //   this.showStandardPicklist = !this.showStandardPicklist;

  //   console.log(this.showStandardPicklist)
  // }

  picklistValueOrderChanged(event) {
    console.log(event.target.value);
    console.log("1", this.picklistOptions);
    var desiredOrder = event.target.value;

    this.picklistOptions.sort((a, b) => {
      const indexA = desiredOrder.indexOf(a.value);
      const indexB = desiredOrder.indexOf(b.value);

      // If not found in the desired order, treat as last
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;

      return indexA - indexB;
    });

    console.log("2", this.picklistOptions);

    var arrayControl = this.attributeForm.get("attributeitems") as FormArray;
    // for (let c of arrayControl.controls) {
    //   if (c.get("attr").value == "options") {
    //     // c.get("value").setValue(optionValue);
    //     console.log(this.valuePicklistForm.controls["sortbyalphabet"].value);
    //     if (this.valuePicklistForm.controls["sortbyalphabet"].value == true) {
    //       this.picklistOptions.sort((a, b) => a.label.localeCompare(b.label));
    //       c.get("value").setValue(this.picklistOptions);
    //     } else {
    //       c.get("value").setValue(this.picklistOptions);
    //     }
    //     console.log(c);

    //     break;
    //   }
    // }
    for (let c of arrayControl.controls) {
      if (c.get("attr").value == "options") {
        console.log(this.valuePicklistForm.controls["sortbyalphabet"].value);
        const sortByAlphabet =
          this.valuePicklistForm.controls["sortbyalphabet"].value;

        // Update the sortbyalphabet flag in each option
        this.picklistOptions.forEach((option) => {
          option.sortbyalphabet = sortByAlphabet; // Update the sortbyalphabet key for each option
        });

        if (sortByAlphabet) {
          // Sort options alphabetically based on label
          this.picklistOptions.sort((a, b) => a.label.localeCompare(b.label));
        }

        // Set the updated options in the form control
        c.get("value").setValue(this.picklistOptions);

        console.log(c);
        break;
      }
    }
  }

  reorder(): void {
    // this.showStandardPicklist = !this.showStandardPicklist;
    this.showStandardPicklist = true;
    // this.editPicklistForm = this.fb.group({
    //   picklistlabel: "",
    //   picklistname: "",
    //   defaultpicklist: false,
    // });
    this.standardpicklistdialogRef = this.dialog.open(
      this.standardPicklistDialog,
      {
        // data: this.data,
        height: "300px",
        width: "600px",
        // disableClose: true,

        panelClass: "custom-dialog-class"
      }
    );

    // this.propertiesDialog = dialogRef.componentInstance;
    // this.propertiesDialog.setParent(this);

    this.standardpicklistdialogRef.afterClosed().subscribe((result) => {
      console.log("Properties dialog was closed");
      if (result) {
      }
    });
  }

  picklistvalueNew(): void {
    // this.showEditPicklistDialog = !this.showEditPicklistDialog;
    this.showEditPicklistDialog = true;
    this.editPicklistForm = this.fb.group({
      picklistlabel: "",
      picklistname: "",
      funnelstage: "",
      defaultpicklist: false,
      exclude: false,
      addtorecordtype: false,
      converted: false,
      closed: false
    });
    this.editpicklistdialogRef = this.dialog.open(this.editPicklistDialog, {
      // data: this.data,
      height: "400px",
      width: "600px",
      // disableClose: true,

      panelClass: "custom-dialog-class"
    });

    // this.propertiesDialog = dialogRef.componentInstance;
    // this.propertiesDialog.setParent(this);

    this.editpicklistdialogRef.afterClosed().subscribe((result) => {
      console.log("Properties dialog was closed");
      if (result) {
      }
    });
  }

  saveStandardPicklist() {
    this.standardpicklistdialogRef.close();
    this.showStandardPicklist = false;
  }

  editPicklistValues(options: any, index: any) {
    console.log(options);
    console.log(index);
    this.selectedIndex = index;

    // this.showEditPicklistDialog = !this.showEditPicklistDialog;
    this.showEditPicklistDialog = true;
    this.oldValues = { options }; // Clone the original options to store as old values

    this.editPicklistForm = this.fb.group({
      picklistlabel: options.picklistlabel,
      picklistname: options.picklistname,
      funnelstage: options.funnelstage,
      defaultpicklist: Boolean(options.defaultpicklist) || false,
      exclude: Boolean(options.exclude) || false,
      addtorecordtype: Boolean(options.addtorecordtype) || false,
      converted: Boolean(options.converted) || false,
      closed: Boolean(options.closed) || false
    });

    this.editpicklistdialogRef = this.dialog.open(this.editPicklistDialog, {
      // data: this.data,
      height: "300px",
      width: "600px",
      // disableClose: true,
      data: { index: index, options: options }, // Pass both index and options
      panelClass: "custom-dialog-class"
    });

    // this.propertiesDialog = dialogRef.componentInstance;
    // this.propertiesDialog.setParent(this);

    this.editpicklistdialogRef.afterClosed().subscribe((result) => {
      console.log("Properties dialog was closed");
      if (result) {
      }
    });
  }

  saveeditPicklist(index: any) {
    console.log(this.picklistOptions);
    console.log(this.editPicklistForm.controls["picklistlabel"].value);
    console.log(this.editPicklistForm.controls["defaultpicklist"].value);
    console.log(this.editPicklistForm.controls["funnelstage"].value);

    if (
      this.editPicklistForm.controls["picklistlabel"].value.toString().trim() ==
      ""
    ) {
      this.showWarning("Picklist label is mandatory");
      return;
    }

    // ✅ Only check funnelstage for Enquiry/Lead + status
    if (
      (this.metaobjectName === "Enquiry" || this.metaobjectName === "Lead") &&
      this.fieldName === "status"
    ) {
      if (
        this.editPicklistForm.controls["funnelstage"].value.toString().trim() ==
        ""
      ) {
        this.showWarning("funnelstage is mandatory");
        return;
      }
    }
    // if (
    //   this.editPicklistForm.controls["funnelstage"].value.toString().trim() ==
    //   ""
    // ) {
    //   this.showWarning("funnelstage is mandatory");
    //   return;
    // }

    console.log("Saved picklist at index:", index); // this.data contains the index

    const newValues = this.editPicklistForm.value; // New form values
    const sortByAlphabet =
      this.valuePicklistForm.controls["sortbyalphabet"].value;
    // Ensure the correct index is used
    console.log("Index of selected row:", this.selectedIndex);

    console.log(newValues);

    if (this.selectedIndex == undefined) {
      const valPush = {
        label: newValues.picklistlabel,
        value: newValues.picklistname,
        funnelstage: newValues.funnelstage,
        defaultpicklist: newValues.defaultpicklist,
        exclude: newValues.exclude,
        addtorecordtype: newValues.addtorecordtype,
        converted: newValues.converted,
        closed: newValues.closed,
        sortbyalphabet: sortByAlphabet
      };
      // this.picklistOptions[this.selectedIndex].label = newValues.picklistlabel;
      // this.picklistOptions[this.selectedIndex].value = newValues.picklistname;
      // this.picklistOptions[this.selectedIndex].defaultpicklist =
      //   newValues.defaultpicklist;

      this.picklistOptions.push(valPush);

      console.log("Updated options array:", this.picklistOptions);

      var arrayControl = this.attributeForm.get("attributeitems") as FormArray;
      for (let c of arrayControl.controls) {
        if (c.get("attr").value == "options") {
          // c.get("value").setValue(optionValue);
          c.get("value").setValue(this.picklistOptions);
          console.log(c);

          break;
        }
      }

      if (this.picklistOptions != null) {
        this.dataSource = this.picklistOptions.map((item) => ({
          // id: item.id,
          // label: item.labelname,
          picklistlabel: item.label,
          picklistname: item.value,
          funnelstage: item.funnelstage,
          defaultpicklist: item.defaultpicklist || false,
          exclude: item.exclude || false,
          addtorecordtype: item.addtorecordtype || false,
          converted: item.converted || false,
          closed: item.closed || false
        }));
      }

      console.log(this.picklistOptions);
      var placeholder = "";
      // placeholder = this.createPlaceholderFromValue(this.picklistOptions);

      // const values = this.picklistOptions.map(item => item.value);
      // let values = "";
      // this.picklistOptions.forEach((item) => {
      //   values += item.value + "\n"; // Adds each value followed by a newline character
      // });
      const picklistValuesString = this.picklistOptions
        .map((item) => item.value)
        .join("\n");
      this.valuePicklistForm.controls["placeholder"].setValue(
        picklistValuesString
      );

      // this.addAttributeItem(
      //   // item.attr,
      //   "options",
      //   // item.type,
      //   "picklist",
      //   values,
      //   placeholder,
      //   // item.hint
      //   ""
      // );

      // // Update the dataSource if necessary
      // this.dataSource[this.selectedIndex] = {
      //   ...this.picklistOptions[this.selectedIndex],
      // };
    }

    // Update the options array with the new values
    if (this.selectedIndex !== undefined && this.selectedIndex >= 0) {
      this.picklistOptions[this.selectedIndex].label = newValues.picklistlabel;
      this.picklistOptions[this.selectedIndex].value = newValues.picklistname;
      this.picklistOptions[this.selectedIndex].funnelstage =
        newValues.funnelstage;
      this.picklistOptions[this.selectedIndex].defaultpicklist =
        newValues.defaultpicklist;
      this.picklistOptions[this.selectedIndex].exclude = newValues.exclude;
      this.picklistOptions[this.selectedIndex].addtorecordtype =
        newValues.addtorecordtype;
      this.picklistOptions[this.selectedIndex].converted = newValues.converted;
      this.picklistOptions[this.selectedIndex].closed = newValues.closed;

      this.picklistOptions[this.selectedIndex].sortbyalphabet = sortByAlphabet;
      console.log("Updated options array:", this.picklistOptions);

      var arrayControl = this.attributeForm.get("attributeitems") as FormArray;
      for (let c of arrayControl.controls) {
        if (c.get("attr").value == "options") {
          // c.get("value").setValue(optionValue);
          c.get("value").setValue(this.picklistOptions);
          console.log(c);

          break;
        }
      }

      if (this.picklistOptions != null) {
        this.dataSource = this.picklistOptions.map((item) => ({
          // id: item.id,
          // label: item.labelname,
          picklistlabel: item.label,
          picklistname: item.value,
          funnelstage: item.funnelstage,
          defaultpicklist: item.defaultpicklist || false,
          exclude: item.exclude || false,
          addtorecordtype: item.addtorecordtype || false,
          converted: item.converted || false,
          closed: item.closed || false
        }));
      }

      // // Update the dataSource if necessary
      // this.dataSource[this.selectedIndex] = {
      //   ...this.picklistOptions[this.selectedIndex],
      // };
    }

    // const picklistValues = this.picklistOptions.map((option) => ({
    //   // label: option.label,
    //   value: option.value,
    // }));

    const picklistValues = this.picklistOptions
      .map((option) => option.value) // Extract the 'value' from each picklist option
      .join("\n"); // Join them with a new line separator

    const picklistLabels = this.picklistOptions
      .map((option) => option.label) // Extract the 'label' from each picklist option
      .join("\n"); // Join them with a new line separator

    const picklistfunnelstages = this.picklistOptions
      .map((option) => option.funnelstage) // Extract the 'label' from each picklist option
      .join("\n"); // Join them with a new line separator

    const defaultPicklist = this.picklistOptions
      .map((option) => option.defaultpicklist) // Extract the 'label' from each picklist option
      .join("\n"); // Join them with a new line separator

    const exclude = this.picklistOptions
      .map((option) => option.exclude) // Extract the 'label' from each picklist option
      .join("\n"); // Join them with a new line separator

    const addtorecordtype = this.picklistOptions
      .map((option) => option.addtorecordtype) // Extract the 'label' from each picklist option
      .join("\n"); // Join them with a new line separator

    const converted = this.picklistOptions
      .map((option) => option.converted) // Extract the 'label' from each picklist option
      .join("\n"); // Join them with a new line separator

    const closed = this.picklistOptions
      .map((option) => option.closed) // Extract the 'label' from each picklist option
      .join("\n"); // Join them with a new line separator

    // console.log(picklistValues);

    const event = {
      target: {
        value: picklistValues, // Use the desired form control value
        label: picklistLabels,
        funnelstage: picklistfunnelstages,
        defaultpicklist: defaultPicklist || false,
        exclude: exclude || false,
        addtorecordtype: addtorecordtype || false,
        converted: converted || false,
        closed: closed || false
      }
    };

    // picklistValueChanged(event: { target: { value: any } }) {

    // }

    this.picklistValueChanged(event);

    this.editpicklistdialogRef.close();
  }

  picklistEditValueChanged(event) {
    console.log(event);
  }

  onKeydown(event: KeyboardEvent): void {
    // List of allowed keys for normal behavior
    const allowedKeys = [
      "Enter",
      "Backspace",
      "Tab",
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
      "Home",
      "End"
    ];

    // Check if Ctrl key is pressed and if the key is C, V, or Z
    const isCtrlPressed = event.ctrlKey || event.metaKey; // Support for both Windows (Ctrl) and macOS (Command)

    if (
      isCtrlPressed &&
      (event.key === "c" ||
        event.key === "C" ||
        event.key === "x" ||
        event.key === "X" ||
        event.key === "v" ||
        event.key === "V" ||
        event.key === "z" ||
        event.key === "Z")
    ) {
      // Allow Ctrl+C, Ctrl+V, Ctrl+Z
      return;
    }

    // Allow all other standard keys like Enter, Arrow keys, Backspace, etc.
    if (allowedKeys.includes(event.key)) {
      return;
    }

    // Prevent typing or any other actions (e.g., typing characters, numbers)
    event.preventDefault();
  }

  saveReOrderPicklist() {
    this.standardpicklistdialogRef.close();
  }

  deletePicklist(label: any, value: any) {
    console.log(label);
    console.log(value);

    this.picklistOptions = this.picklistOptions.filter(
      (option: any) => option.label !== label || option.value !== value
    );
    console.log(this.picklistOptions);
    // this.dataSource = [...this.picklistOptions];
    this.dataSource = this.picklistOptions.map((item) => ({
      // id: item.id,
      // label: item.labelname,
      picklistlabel: item.label,
      picklistname: item.value,
      funnelstage: item.funnelstage,
      defaultpicklist: item.defaultpicklist,
      exclude: item.exclude,
      addtorecordtype: item.addtorecordtype,
      converted: item.converted,
      closed: item.closed
    }));
  }

  save() {
    // console.log("GYTYVVHGVCYTHT", this.fieldAttributeArray);
    this.sharedDataService.userDetails$.subscribe((user) => {
      console.log("User from service:", user);
    });
    this.isLoading = false;
    this.isError = false;

    const fieldTypes =
      this.detailForm.controls["fieldtype"].value.toLowerCase();

    let pairCtrl = null;
    const arrayControls = this.attributeForm.get("attributeitems") as FormArray;

    if (arrayControls) {
      for (let c of arrayControls.controls) {
        if (c.get("attr") && c.get("attr").value === "pairfieldname") {
          pairCtrl = c.get("value");
          break;
        }
      }
    }

    if (fieldTypes === "mlookup" && (!pairCtrl || !pairCtrl.value)) {
      this.showWarning("Pair Field Name is mandatory for MLookup fieldtype");
      return;
    }

    let relatedCtrl = null;

    if (arrayControls) {
      for (let c of arrayControls.controls) {
        if (c.get("attr") && c.get("attr").value === "relatedto") {
          relatedCtrl = c.get("value");
          break;
        }
      }
    }

    if (fieldTypes === "lookup" && (!relatedCtrl || !relatedCtrl.value)) {
      this.showWarning("relatedto is mandatory for Lookup fieldtype");
      return;
    }

    if (this.detailForm.controls["labelname"].value.toString().trim() == "") {
      this.showWarning("Field label is mandatory");
      return;
    }
    if (this.detailForm.controls["fieldname"].value.toString().trim() == "") {
      this.showWarning("Field name is mandatory");
      return;
    }
    if (this.detailForm.controls["fieldtype"].value.toString().trim() == "") {
      this.showWarning("Field type is mandatory");
      return;
    }

    console.log(this.filterForm);

    console.log(this.fieldUsageForm);

    if (this.detailForm.invalid) {
      this.errorMessage =
        "The fields [Name], [Label] and [Type] are mandatory.";
      return;
    }
    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      this.metafieldId = this.guid.getGUID("metafield");
    }

    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

    const complianceValue = this.compliancesDone.map(
      (compliance) => compliance.value
    );

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      profilename: userDetail.profilename,
      data: {
        metafield: {
          metaapplicationid: this.applicationId,
          metaobjectid: this.metaobjectId,
          parentobjectid: this.parentobjectId,
          embeddedobject: this.embeddedObject,
          virtualobject: this.virtualObject,
          mode: this.mode,
          id: this.metafieldId,
          labelname: this.detailForm.controls["labelname"].value.trim(),
          fieldname: this.detailForm.controls["fieldname"].value
            .toLocaleLowerCase()
            .replace(/ /g, "")
            .trim(),
          fieldtype: this.detailForm.controls["fieldtype"].value,
          standard: this.detailForm.controls["standard"].value,
          primaryfield: this.detailForm.controls["primaryfield"].value,
          required: this.detailForm.controls["required"].value,
          tenantfield: this.detailForm.controls["tenantfield"].value,
          defaultvalue: this.detailForm.controls["defaultvalue"].value.trim(),
          description: this.detailForm.controls["description"].value.trim(),
          hinttext: this.detailForm.controls["hinttext"].value.trim(),
          helptext: this.detailForm.controls["helptext"].value.trim(),
          active: this.detailForm.controls["active"].value,
          fieldusage: this.fieldUsageForm.controls["fieldusage"].value,
          datasensitivitylevel:
            this.fieldUsageForm.controls["sensitivitylevel"].value,
          deprecatedversionseq:
            this.detailForm.controls["deprecatedversionseq"].value != null
              ? this.detailForm.controls["deprecatedversionseq"].value
              : 0,
          sinceversionseq:
            this.detailForm.controls["sinceversionseq"].value != null
              ? this.detailForm.controls["sinceversionseq"].value
              : 0,

          compliancecategorization: complianceValue,
          attributes: {},
          metaprofilefields: [],
          metafieldrelation: [],
          fieldlabeltranslation: [],
          lookupfilters: []
        }
      }
    };

    //formulate field attributes and assign it to postoption
    //get formarray details
    var attrbs = {};
    var attributes = [];

    var arrayControl = this.attributeForm.get("attributeitems") as FormArray;
    // for (let c of arrayControl.controls) {
    //   console.log(c);
    //   attrbs[c.get("attr").value] = c.get("value").value;
    // }

    for (let c of arrayControl.controls) {
      console.log(c);
      let attrValue = c.get("value").value;
      let attrType = c.get("type").value;

      // console.log(attrType);
      // console.log(attrValue);

      // Convert to integer if the value is a number
      if (attrType === "number") {
        attrbs[c.get("attr").value] = parseInt(attrValue, 10);
      } else {
        attrbs[c.get("attr").value] = attrValue;
      }

      if (attrType === "picklist") {
        console.log(this.valuePicklistForm.controls["sortbyalphabet"].value);
        if (this.valuePicklistForm.controls["sortbyalphabet"].value == true) {
          this.picklistOptions.sort((a, b) => a.label.localeCompare(b.label));
          // c.get("value").setValue(this.picklistOptions);
          attrbs[c.get("attr").value] = this.picklistOptions;
        } else {
          attrbs[c.get("attr").value] = this.picklistOptions;
        }
      }
    }
    console.log(arrayControl);
    console.log("attrbs", attrbs);

    //push attributes to request data (postoption)
    postOption.data.metafield.attributes = attrbs;

    attributes.push(attrbs);

    // console.log(attributes[0].relatedto);

    //get metaprofile details and assign it to postoption
    //get formarray details
    var arrMetaProfileFields = [];
    var arrayControl = this.profileForm.get("metaprofilefields") as FormArray;
    for (let c of arrayControl.controls) {
      var metaProfileField = {
        id: this.guid.getGUID("metaprofilefield"),
        organizationid: c.get("organizationid").value,
        metaobjectid: c.get("metaobjectid").value,
        parentobjectid: c.get("parentobjectid").value,
        embeddedobject: c.get("embeddedobject").value,
        metafieldid: this.metafieldId,
        profileid: c.get("profileid").value,
        visible: c.get("visible").value,
        readonly: c.get("readonly").value
      };

      //push it to array
      arrMetaProfileFields.push(metaProfileField);
    }

    var metaFieldRelation = {
      id: this.guid.getGUID("metafieldrelation"),
      organizationid: localStorage.getItem("crm_orgid"),
      metaobjectid: this.metaobjectId,
      fieldname: this.detailForm.controls["fieldname"].value.trim(),
      fieldid: this.metafieldId,
      relatedto: attributes[0].relatedto,
      relationvisibility: attributes[0].relationvisibility,
      active: this.detailForm.controls["active"].value,
      attributes: {}
    };

    metaFieldRelation.attributes = attrbs;
    attributes.push(attrbs);

    postOption.data.metafield.metafieldrelation.push(metaFieldRelation);

    //push arrmetaprofilefield to request data (postoption)
    postOption.data.metafield.metaprofilefields = arrMetaProfileFields;

    var arrfilters = [];

    var arrayControl = this.filterForm.get("filteritems") as FormArray;

    for (let c of arrayControl.controls) {
      var fieldId = c.get("fieldid").value;
      var fieldName = c.get("fieldname").value;
      var fieldType = c.get("fieldtype").value;
      var type = c.get("type").value;
      var metaObjName = c.get("metaobjectname").value;

      var operator = c.get("fieldoperator").value;
      if (
        operator.toLowerCase().trim() == "--none--" ||
        operator.toLowerCase().trim() == ""
      )
        operator = "";

      var value = c.get("fieldvalue").value;
      // if (value.toLowerCase().trim() == "--none--") value = "";
      if (value == "--none--") value = "";

      if (fieldId != "" && operator != "") {
        if (fieldType === "checkbox") {
          // Convert value to boolean (checkbox typically sends a 'true'/'false' string or '1'/'0')
          value = Boolean(value);
        }
        console.log(metaObjName);

        // var filterFieldName = "";
        // if (metaObjName == this.metaobjectName) {
        //   filterFieldName = fieldId;
        // } else {
        //   console.log(fieldId);
        //   const fieldNameValue =
        //     this.detailForm.controls["fieldname"].value.trim();

        //   // Check if the fieldName already contains a dot (or other delimiter)
        //   if (fieldId.includes(".")) {
        //     filterFieldName = fieldId;
        //   } else {
        //     filterFieldName = `${fieldNameValue}.${fieldId}`;
        //   }
        // }

        var lookupFilter = {
          id: this.guid.getGUID("metalookupfilter"),
          metaobjectid: this.metaobjectId,
          // metalayoutid: this.metalayoutId,
          metafieldid: this.metafieldId,
          filterfieldid: fieldName,
          filterfieldname: fieldId,
          // filterfieldname: filterFieldName,
          filterfieldtype: fieldType,
          operator: operator,
          value: value,
          type: type,
          // filterlogic: c.get("filterlogic").value,
          filterlogic: this.filterForm.controls["filterlogic"].value,

          filtertype: this.filterForm.controls["filtertype"].value,
          errormessage: this.filterForm.controls["errormessage"].value,
          lookuptext: this.filterForm.controls["lookuptext"].value,
          active: this.filterForm.controls["active"].value
        };

        //push it to array
        arrfilters.push(lookupFilter);
      }
    }
    console.log("filter *****", arrfilters);
    postOption.data.metafield.lookupfilters = arrfilters;

    if (this.mode.toLocaleLowerCase() == "edit") {
      var arrtranslatedFields = [];
      for (let translatedfieldlabel of this.translatedLabels) {
        var fieldlabelTranslation = {
          id: this.guid.getGUID("metafieldlabeltranslation"),
          organizationid: localStorage.getItem("crm_orgid"),
          metafieldid: this.metafieldId,
          languagecode: translatedfieldlabel.languageCode,
          translatedlabel: translatedfieldlabel.translatedName,
          active: true
        };

        //push it to array
        arrtranslatedFields.push(fieldlabelTranslation);
      }
      postOption.data.metafield.fieldlabeltranslation = arrtranslatedFields;
    }
    console.log("postOption", postOption);

    this.isLoading = true;
    this.dataService.upsertMetafield(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl(
            "/home/metafielddetail/" +
              this.metafieldId +
              "/" +
              this.detailForm.controls["fieldname"].value.trim() +
              "/" +
              this.metaobjectId +
              "/" +
              this.metaobjectName +
              "/" +
              (this.parentobjectId == "" ? "none" : this.parentobjectId) +
              "/" +
              (this.parentobjectName == "" ? "none" : this.parentobjectName) +
              "/" +
              this.embeddedObject +
              "/" +
              this.virtualObject
          );
          // const currentUrl = this.router.url;

          // this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
          //   this.router.navigate([currentUrl]);
          // });
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
